import find from 'lodash/find';
import includes from 'lodash/includes';

import type { AppData } from '../../types/app_data';
import { AppStepSection, StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';
import { RelationToUser } from '../../types/driver';
import {
  GEICO_OCCUPATION_EXCLUSION_STATES,
  isValidOccupation,
  OCCUPATION_EXCLUSION_STATES,
} from '../../utils/occupations';
import { isEligibleForGeicoQuotes } from '../../utils/onboard';

// Ask user for their occupation
export const OccupationStep: Step = {
  id: 'occupation',
  pathname: '/occupation',

  // Show if user has valid address state and user is not from partner traffic with occupation data.
  canShow: (appData: AppData) => {
    const userDriver = find(appData.drivers, (driver) => driver.relationToUser === RelationToUser.Insured);

    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    if (appData.stepSection === AppStepSection.Challenge) {
      // Skip the step is it's already answered
      if (userDriver?.industry && userDriver.occupation && isValidOccupation(userDriver.occupation)) {
        return false;
      }
    }

    // If prefilled occupation for primary&spouse driver, skip the step
    if (
      appData.signupParams?.partnerSignup &&
      appData.partnerSkippableData?.hasOccupationPrimaryDriverID === userDriver?.id
    ) {
      return false;
    }

    return (
      !appData.isOnboardingLite &&
      (isEligibleForGeicoQuotes(appData)
        ? !includes(GEICO_OCCUPATION_EXCLUSION_STATES, appData?.address?.state)
        : !includes(OCCUPATION_EXCLUSION_STATES, appData?.address?.state))
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    const userDriver = find(appData.drivers, (driver) => driver.relationToUser === RelationToUser.Insured);
    return (!!userDriver?.occupation && !!userDriver?.industry) || !!appData.primaryDriverOccupation;
  },
  category: () => StepCategory.Drivers,
};
